module.exports = __webpack_public_path__ + "static/media/nugget-point.b138c309.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photography/nugget-point.jpg
// module id = 142
// module chunks = 0